/*
* Copyright (c) 2023 Eugenio Espinoza
*/

import React from 'react';
import { Link } from 'react-router-dom';
import { rosterList } from './artistsData';
import './RosterGrid.css';

function RosterGrid() {
  return (
    <section className="mt-rosterPage">
      <div className="mt-container mt-rosterPage__top">
        <div className="mt-rosterPage__topNote">
          <span className="mt-kicker">{rosterList.length} Artists · Est. 2015</span>
          <p>
            Una familia cuidadosamente construida: seis firmas independientes con
            lenguajes distintos — unidos por el oficio de decir la verdad a través
            del sonido.
          </p>
        </div>
      </div>

      <ul className="mt-rosterPage__list mt-container">
        {rosterList.map((a, i) => {
          const CardTag = a.external ? 'a' : Link;
          const linkProps = a.external
            ? { href: a.path, target: '_blank', rel: 'noopener noreferrer' }
            : { to: a.path };
          return (
            <li key={a.name} className="mt-rosterPage__row">
              <CardTag {...linkProps} className="mt-rosterPage__link">
                <span className="mt-rosterPage__num">0{i + 1}</span>

                <div className="mt-rosterPage__media">
                  <img src={a.portrait} alt={a.name} loading="lazy" />
                </div>

                <div className="mt-rosterPage__main">
                  <h2 className="mt-rosterPage__name">
                    {a.displayFirst || a.name}
                    {a.displayItalic && <em> {a.displayItalic}</em>}
                  </h2>
                  {a.tagline && <p className="mt-rosterPage__tag">{a.tagline}</p>}
                </div>

                <div className="mt-rosterPage__meta">
                  <span>{a.city || '—'}</span>
                  <span>{a.genre || '—'}</span>
                  <span>Signed {a.year || '—'}</span>
                </div>

                <span className="mt-rosterPage__arrow" aria-hidden="true">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <path d="M5 12h14M13 6l6 6-6 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </span>
              </CardTag>
            </li>
          );
        })}
      </ul>

      <div className="mt-container mt-rosterPage__cta">
        <div>
          <span className="mt-kicker">Submissions</span>
          <h3>
            ¿Tienes un proyecto?<br />
            <em>Escucharemos.</em>
          </h3>
        </div>
        <a href="mailto:demos@masteredtrax.com" className="mt-btn mt-btn--primary">
          <span>Enviar demo</span>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
            <path d="M5 12h14M13 6l6 6-6 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </a>
      </div>
    </section>
  );
}

export default RosterGrid;
